module.exports = __webpack_public_path__ + "static/media/patnawebp.4bf1193b.webp";